import { Box } from "@mui/material";
import { useRef, useState } from "react";
import PanelSidebar from "./PanelSidebar/PanelSidebar";
import PanelHeader from "./PanelHeader/PanelHeader";
import PanelContent from "./PanelContent/PanelContent";
import "./AdministratorPanel.scss";

export default function AdministratorPanel() {
  const [menuToShow, setMenuToShow] = useState("ideas");
  const [headerTitle, setHeaderTitle] = useState("inicio");
  const [selectedIdea, setSelectedIdea] = useState<any | null>(null);

  const refB = useRef<{ save: () => void }>(null);

  const handleSave = () => {
    refB.current?.save();
  };

  const updateContent = (menu: string) => {
    setMenuToShow(menu);
    setHeaderTitle(menu);
  };

  return (
    <Box className="administratorLayout">
      <PanelSidebar updateContent={updateContent} />
      <div className="administratorLayout__container">
        <PanelHeader
          title={headerTitle}
          menu={menuToShow}
          updateContent={updateContent}
          selectedIdea={selectedIdea}
          onSave={handleSave}
        />
        <PanelContent
          selectedIdea={selectedIdea}
          ref={refB}
          menuToShow={menuToShow}
          updateContent={updateContent}
          onSend={setSelectedIdea}
        />
      </div>
    </Box>
  );
}
